import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppSelector} from "common/hook/UseSelector";
import {useAppDispatch} from "common/hook/UseDispatch";
import {isFoolPopupServiceAC, setPopupsOfflineAC} from "app/popups-reducer";

interface ServiceWorkerMessageEvent extends MessageEvent {
    data: {
        type: 'FORM_POST_REQUEST_ERROR' | 'PAGE_LOAD_ERROR' | 'POST_REQUEST_ERROR' | 'ALL_REQUESTS_SENDED';
    };
}

const useServiceWorkerMessage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isPopupsOffline = useAppSelector((state) => state.popups.isPopupsOffline);
    const isFoolPopupService = useAppSelector((state) => state.popups.isFoolPopupService);

    useEffect(() => {
        const handleOnlineEvent = () => {
            navigate('/');
        };

        window.addEventListener('online', handleOnlineEvent);

        return () => {
            window.removeEventListener('online', handleOnlineEvent);
        };
    }, [navigate]);


    useEffect(() => {
        const handleServiceWorkerMessage = async (event: ServiceWorkerMessageEvent) => {

            switch (event.data.type) {
                case 'FORM_POST_REQUEST_ERROR':
                    // Используем имя кэша, которое создается внутри сервис-воркера
                    const cacheName = 'main'; // Замените на фактическое имя из сервис-воркера
                    if (await isCurrentRouteCached(cacheName)) {
                        var showOfflinePopupEvent = new CustomEvent("showOfflinePopupEvent", {});
                        window.dispatchEvent(showOfflinePopupEvent);
                    } else {
                        navigate('/offline');
                    }
                    break;
                case 'PAGE_LOAD_ERROR':
                    navigate('/offline');
                    break;
                case 'POST_REQUEST_ERROR':
                    // здесь попап
                    dispatch(setPopupsOfflineAC(!isPopupsOffline));
                    dispatch(isFoolPopupServiceAC(!isFoolPopupService))
                    break;
                // case 'ALL_REQUESTS_SENDED':
                //     alert('Ваши данные отправленны на сервер')
                //     break;
                default:
                    break;
            }
        };

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
        } else {
            console.log('Service Worker is not supported in this browser.');
        }

        return () => {
            // Очистка слушателя при размонтировании компонента
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
            }
        };
    }, [navigate]);

    // Функция для проверки, закэширован ли текущий маршрут
    const isCurrentRouteCached = async (cacheName: string) => {
        if ('caches' in window.navigator) {
            const cache = await caches.open(cacheName);
            const response = await cache.match(window.location.href);

            return !!response;
        }

        return false;
    };
};

export default useServiceWorkerMessage;

